"use client";

import { useEffect, useState } from "react";
import { useParams, usePathname } from "next/navigation";
import { boundaryLocale, loadBoundaryCopy, type BoundaryCopy } from "./boundary-copy";

export function useBoundaryCopy() {
	const params = useParams<{ locale?: string }>();
	const pathname = usePathname();
	const locale = boundaryLocale(params?.locale, pathname);
	const [loaded, setLoaded] = useState<{ locale: string; copy: BoundaryCopy | null } | null>(null);
	useEffect(() => {
		if (!locale) return;
		let cancelled = false;
		void loadBoundaryCopy(locale)
			.then((copy) => {
				if (!cancelled) setLoaded({ locale, copy });
			})
			.catch((error: unknown) => {
				console.error("[i18n] Runtime boundary copy unavailable", locale, error);
				if (!cancelled) setLoaded({ locale, copy: null });
			});
		return () => {
			cancelled = true;
		};
	}, [locale]);
	return {
		locale,
		copy: loaded?.locale === locale ? loaded.copy : null,
		pending: Boolean(locale && loaded?.locale !== locale),
	};
}
